import { confirmAlert } from "react-confirm-alert";
import { ConfirmAlerHometTypes } from "../ConfirmAlerHometTypes";
import "../SCSS/styles.css";

function ConfirmAlertHome({ confirmParameters }: ConfirmAlerHometTypes) {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div
          className={
            confirmParameters.isMobile ? "mobile-resp-custom-ui" : "custom-ui"
          }
        >
          <div className="delete-title">
            <span className="delete-img-cover">
              <img
                className="delete-img"
                src={confirmParameters.title.images}
                alt="confirm"
                style={{ height: "3em", width: "3em" }}
              />
            </span>
            <span className="delete-text">
              {confirmParameters.enableDescription ? (
                <h1 className="delete-text-header">
                  {confirmParameters.title.titleName}
                </h1>
              ) : (
                <h1> Alert</h1>
              )}
            </span>
          </div>

          {confirmParameters.enableDescription && (
            <div className="delete-description">
              {confirmParameters.descriptions.first && (
                <p className="delete-description-text-one">
                  {confirmParameters.descriptions.first}
                </p>
              )}
              {confirmParameters.descriptions.second && (
                <p className="delete-description-text-two">
                  {confirmParameters.descriptions.second}
                </p>
              )}
              {confirmParameters.descriptions.second && (
                <p className="delete-description-text-two">
                  {confirmParameters.descriptions.third}
                </p>
              )}
            </div>
          )}
          {confirmParameters.note && (
            <div className="note">{confirmParameters.note}</div>
          )}
          <div className="delete-button-covers">
            <button
              className={confirmParameters?.buttonClassName?.no}
              onClick={() => onClose()}
            >
              {confirmParameters.buttons.No}
            </button>
            <button
              className={confirmParameters?.buttonClassName?.yes}
              onClick={() => {
                confirmParameters?.onClick();
                confirmParameters.enableOnClose && onClose();
              }}
            >
              {confirmParameters.buttons.Yes}
            </button>
          </div>
        </div>
      );
    },
  });
}

export default ConfirmAlertHome;
